/* eslint-disable react/no-danger */
import styles from './BlogPage.module.css';
import helperStyles from './Helpers.module.css';
import { Post } from '../types/api';
import Date from './Date';
import PostPreviewBox from './PostPreviewBox';

interface Props {
  post: Partial<Post>;
  morePosts: Post[];
}

const Component: React.FC<Props> = ({ post, morePosts }) => (
  <main>
    <article>
      <div
        style={{
          maxWidth: '580px',
          display: 'flex',
          justifyContent: 'flex-start',
        }}
        className={styles.coverContainer}
      >
        <picture>
          <source srcSet={post.coverImage?.webp} type="image/webp" />
          <source srcSet={post.coverImage?.url} type="image/png" />
          <source srcSet={post.coverImage?.url} type="image/jpeg" />
          <img
            src={post.coverImage?.url}
            alt="Cover"
            style={{
              width: '100%',
            }}
          />
        </picture>
      </div>
      <section
        className={`${helperStyles.sidePadding} ${styles.section}`}
        style={{
          maxWidth: '580px',
          margin: '0 auto',
        }}
      >
        <div className={styles.content}>

          <h1 style={{
            margin: '30px 0',
            fontSize: '42px',
          }}
          >
            {post.title}
          </h1>

          <Date dateString={post.date as string} />

          <div
            style={{ margin: '15px 0' }}
            className={styles.postWrapper}
            dangerouslySetInnerHTML={{ __html: post.content?.html as string }}
          />
        </div>
      </section>
      <section
        id="share-section"
        className={`${helperStyles.sidePadding} ${styles.section}`}
        style={{
          maxWidth: '580px',
          margin: '0 auto',
        }}
      >
        <h2 style={{
          margin: '1em 0',
        }}
        >
          انشر المقالة
        </h2>
        <div className={styles.shareButtons}>

          <a
            href={`https://www.facebook.com/dialog/share?app_id=496714831572282&display=popup&href=${encodeURI(`https://ashourguitar.com/blog/${encodeURIComponent(post.slug || '')}` || '')}&redirect_uri=${encodeURI(`https://ashourguitar.com/blog/${encodeURIComponent(post.slug || '')}#share-section` || '')}`}
            className={styles.shareButton}
          >
            <p>
              انشر على فيسبوك
            </p>
            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-facebook" width="40" height="40" viewBox="0 0 24 24" strokeWidth="1" stroke="#000" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />
            </svg>

          </a>

          <a
            href={`https://api.whatsapp.com/send?text=${encodeURI(`https://ashourguitar.com/blog/${encodeURIComponent(post.slug || '')}` || '')}`}
            className={styles.shareButton}
            target="_blank"
            rel="noreferrer"
          >
            <p>
              ابعت عن طريق الواتساب
            </p>
            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-whatsapp" width="40" height="40" viewBox="0 0 24 24" strokeWidth="1" stroke="#000000" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9" />
              <path d="M9 10a0.5 .5 0 0 0 1 0v-1a0.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a0.5 .5 0 0 0 0 -1h-1a0.5 .5 0 0 0 0 1" />
            </svg>
          </a>

          <a
            href={`https://twitter.com/share?text=${post.title}&url=${encodeURI(`https://ashourguitar.com/blog/${encodeURIComponent(post.slug || '')}`)}&hashtags=ashour_guitar,عاشور_جيتار`}
            className={styles.shareButton}
            target="_blank"
            rel="noreferrer"
          >
            <p>
              انشر على تويتر
            </p>
            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-twitter" width="40" height="40" viewBox="0 0 24 24" strokeWidth="1" stroke="#000000" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M22 4.01c-1 .49 -1.98 .689 -3 .99c-1.121 -1.265 -2.783 -1.335 -4.38 -.737s-2.643 2.06 -2.62 3.737v1c-3.245 .083 -6.135 -1.395 -8 -4c0 0 -4.182 7.433 4 11c-1.872 1.247 -3.739 2.088 -6 2c3.308 1.803 6.913 2.423 10.034 1.517c3.58 -1.04 6.522 -3.723 7.651 -7.742a13.84 13.84 0 0 0 .497 -3.753c-.002 -.249 1.51 -2.772 1.818 -4.013z" />
            </svg>
          </a>
        </div>
      </section>
    </article>
    <section
      id="read-more"
      className={`${helperStyles.sidePadding} ${styles.section}`}
      style={{
        maxWidth: '580px',
        margin: '0 auto',
      }}
    >
      <h2 style={{ margin: '1em 0' }}>
        اقرأ المزيد
      </h2>

      <div className={styles.morePostsContainer}>
        {morePosts.map((morePost) => (
          <PostPreviewBox post={morePost} key={morePost.title} />
        ))}
      </div>
    </section>
  </main>
);

export default Component;
